import { Navigate, Outlet } from "react-router-dom";
import { getUserEmail, getDefaultRoute } from "../utils/permissions";

const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  return token !== null;
};

export const PublicRoute = () => {

  if (isAuthenticated()) {
    return <Navigate to={getDefaultRoute(getUserEmail())} />;
  }

  return (
    <Outlet className="example" />
  )
};